/**
 * Reduce a message to one line of plain text, for the places that show a preview rather than render it.
 *
 * A sidebar row is a single unstyled line, so markup the bubble turns into formatting arrives there as
 * literal punctuation. Emphasis, code spans, link syntax and line-leading markers go; the words stay in
 * order. A lone underscore is left alone — identifiers carry more of them than italics do.
 *
 * It sits apart from the renderer because it is pure string work: the renderer installs a DOMPurify hook at
 * module load, so anything importing it needs a DOM, and a preview is wanted in places that have none.
 */
export function plainPreview(text: string): string {
  return text
    .split("\n")
    .map((line) =>
      line
        .trim()
        .replace(/^\s*(?:```|~~~)\s*[A-Za-z0-9_+-]*\s*$/, "")
        .replace(/^#{1,6}\s+/, "")
        .replace(/^[-*+]\s+/, "")
        .replace(/^>\s*/, "")
        .replace(/^\d+[.)]\s+/, ""),
    )
    .filter((line) => line.trim().length > 0)
    .join(" ")
    .replace(/!?\[([^\]]*)]\([^)]*\)/g, "$1")
    .replace(/(\*\*|__|`)/g, "")
    .replace(/\*([^*\s][^*]*)\*/g, "$1")
    .replace(/\s+/g, " ")
    .trim();
}
